import React from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ProductDetails as ProductDetailsOG } from '../ProductDetails.component';

export const PEPProductDetails = ({ itemId }) => {
  return (
    <ProductDetailsOG itemId={itemId}>
      <div className="product-details__badge-title--wrapper">
        <ProductDetailsOG.Badge itemId={itemId} />
        <ProductDetailsOG.Title link />
      </div>
      <ProductDetailsOG.BrandCollection showCollection />
      <ProductDetailsOG.Ratings
        pageType="PEP"
        showBadge={false}
        disableReviewsIfZero
      />
    </ProductDetailsOG>
  );
};

PEPProductDetails.propTypes = {
  itemId: PropTypes.string.isRequired
};

PEPProductDetails.displayName = 'PEPProductDetails';

PEPProductDetails.dataModel = extend({}, ProductDetailsOG);